import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import InputText from "../sectioninput/formelement/InputText";
import _ from "lodash";
import { updateProduct } from "../../REDUX/actions/products";
import ProductSubmitButton from "./ProductSubmitButton";
import Uploader from "../Common/Uploader";

import Lists from "../Lists/Lists";
import { Accordion, Button, Form } from "react-bootstrap";
import { productUrlRewrite } from "../../utils/utils";
import CustomDropDown from "../sectioninput/formelement/CustomDropDown";
import API from "../../Api/Api";

const ProductForm = ({ productItem }) => {
  const dispatch = useDispatch();

  const [caracteristiques, setCaracteristiques] = useState([]);
  const [selectedCaracteristiques, setSelectedCaracteristiques] = useState(
    productItem.attributes.caracteristiques.data.map((carac) => carac.id) || []
  );
  const [newCaracteristique, setNewCaracteristique] = useState("");
  const [productInputs, setproductInputs] = useState(
    productItem
      ? _.omit(productItem.attributes, [
          "caracteristiques",
          "seo",
          "list",
          "updatedAt",
          "createdAt",
        ])
      : {}
  );

  const handleProductChange = (value, champs) => {
    const newValue = value === "" ? null : value;
    setproductInputs({ ...productInputs, [champs]: newValue });
  };

  const [image, setimage] = useState(productItem.attributes.mainImage.data);
  const handleSwitchChange = (caracteristiqueId, checked) => {
    setSelectedCaracteristiques((prev) =>
      checked
        ? [...prev, caracteristiqueId]
        : prev.filter((id) => id !== caracteristiqueId)
    );
  };
  const handleUpdateProduct = () => {
    // return console.log(productInputs);
    dispatch(
      updateProduct(productItem.id, {
        ...productInputs,
        path: productUrlRewrite(productItem.id, productInputs.name),
        caracteristiques: selectedCaracteristiques,

        mainImage: image.id,
      })
    );
  };
  const addCaracteristique = async () => {
    if (!newCaracteristique.trim()) return;
    try {
      const response = await API.post("api/caracteristiques", {
        data: { name: newCaracteristique },
      });
      const addedCaracteristique = response.data.data;
      setCaracteristiques((prev) => [...prev, addedCaracteristique]);
      setNewCaracteristique("");
    } catch (error) {
      console.error("Error adding new caracteristique:", error);
    }
  };
  useEffect(() => {
    setproductInputs(
      productItem
        ? _.omit(productItem.attributes, [
            "caracteristiques",
            "seo",
            "list",
            "updatedAt",
            "createdAt",
          ])
        : {}
    );

    setimage(productItem.attributes.mainImage.data);

    const fetchCaracteristiques = async () => {
      try {
        const response = await API.get("api/caracteristiques");
        //console.log("response", response);
        setCaracteristiques(response.data.data);
      } catch (error) {
        console.error("Error fetching caracteristiques:", error);
      }
    };

    fetchCaracteristiques();
  }, [productItem, productItem.id]);

  const handleImage = (imageSelected) => {
    setimage(imageSelected);
  };

  const itemStyle = "card-body noBorder mb-4 p-0 rounded-10";
  const headerStyle = "mb-0 f24 fw-normal text-orange";

  return (
    <Accordion className=" rounded-10 mt-4 ">
      <Accordion.Item className={itemStyle} eventKey="0">
        <Accordion.Header className="d-flex align-items-center">
          <h2 className={headerStyle}>Séction Générale</h2>
        </Accordion.Header>
        <Accordion.Body>
          <div className="w-30 mb-4 m-auto">
            <Uploader
              targetScreen="tout écran"
              labelinput="Image principale"
              handleImage={handleImage}
              image={image}
              resolution={"Carré"}
            />
          </div>
          <div className="d-flex flex-wrap  justify-content-center">
            <div className="w-50 px-3">
              <InputText
                labelinput="Nom du bien"
                handleChange={handleProductChange}
                champs="name"
                value={productInputs.name}
                disabled
              />
            </div>

            <div className="w-50 px-3">
              <InputText
                labelinput="Ville"
                handleChange={handleProductChange}
                champs="city"
                value={productInputs.city}
              />
            </div>

            <div className="w-50 px-3">
              <CustomDropDown
                options={[
                  { text: "Maison", value: "maison" },
                  { text: "Appartement", value: "appartement" },
                  { text: "Local commercial", value: "local commercial" },
                ]}
                value={productInputs.typeBien}
                handleChange={handleProductChange}
                champs="typeBien"
                label="Type du Bien"
              />
            </div>

            <div className="w-50 px-3">
              <InputText
                labelinput="Superficie habitable (m²)"
                handleChange={handleProductChange}
                champs="surfaceHabitable"
                type="number"
                value={productInputs.surfaceHabitable || "non Mentionné"}
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Superficie Terrain (m²)"
                handleChange={handleProductChange}
                champs="surfaceTerrain"
                type="number"
                value={productInputs.surfaceTerrain || "non Mentionné"}
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Superficie totale (m²)"
                handleChange={handleProductChange}
                champs="surfaceTotale"
                type="number"
                value={productInputs.surfaceTotale || "non Mentionné"}
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Nombre des pieces"
                handleChange={handleProductChange}
                champs="nbrPieces"
                type="number"
                value={productInputs.nbrPieces || "non Mentionné"}
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Nombre des chambres"
                handleChange={handleProductChange}
                champs="nbrChambres"
                type="number"
                value={productInputs.nbrChambres || "non Mentionné"}
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Nombre des SDB"
                handleChange={handleProductChange}
                champs="nbrSDB"
                type="number"
                value={productInputs.nbrSDB || "non Mentionné"}
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Année de construction"
                handleChange={handleProductChange}
                champs="anneeConstruction"
                type="number"
                value={productInputs.anneeConstruction || "non Mentionné"}
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Etat du bien"
                handleChange={handleProductChange}
                champs="etat"
                type="text"
                value={productInputs.etat}
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Prix (€)"
                handleChange={handleProductChange}
                champs="prix"
                type="number"
                value={productInputs.prix}
                disabled
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Parking"
                handleChange={handleProductChange}
                champs="parking"
                type="number"
                value={productInputs.parking}
                disabled
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Etage"
                handleChange={handleProductChange}
                champs="etages"
                type="number"
                value={productInputs.etages}
                disabled
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Type de certificat énergétique"
                handleChange={handleProductChange}
                champs="typeCertifEnergitique"
                type="text"
                value={productInputs.typeCertifEnergitique}
                disabled
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Type de chauffage"
                handleChange={handleProductChange}
                champs="typeChauffage"
                type="text"
                value={productInputs.typeChauffage}
                disabled
              />
            </div>
            <div className="w-50 px-3">
              <InputText
                labelinput="Source d'énergie"
                handleChange={handleProductChange}
                champs="sourceNRJ"
                type="text"
                value={productInputs.sourceNRJ}
                disabled
              />
            </div>
            <div className="w-50 px-3">
              <CustomDropDown
                options={[
                  { text: "A+", value: "A+" },
                  { text: "A", value: "A" },
                  { text: "B", value: "B" },
                  { text: "C", value: "C" },
                  { text: "D", value: "D" },
                  { text: "E", value: "E" },
                  { text: "F", value: "F" },
                  { text: "G", value: "G" },
                  { text: "H", value: "H" },
                ]}
                value={productInputs.efficaciteEnergetique}
                handleChange={handleProductChange}
                champs="efficaciteEnergetique"
                label="Classe d'efficacité énergétique"
              />
            </div>
            <div className="w-100 px-3">
              <InputText
                textArea
                labelinput="Description"
                handleChange={handleProductChange}
                champs="description"
                type="text"
                value={productInputs.description}
              />
            </div>
            <div className="w-100 px-3">
              <InputText
                textArea
                labelinput="Localisation"
                handleChange={handleProductChange}
                champs="localisation"
                type="text"
                value={productInputs.localisation}
              />
            </div>
            <div className="w-50 px-3">
              <ProductSubmitButton
                handleUpdateProduct={handleUpdateProduct}
                productInputs={productInputs}
              />
            </div>
          </div>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item className={itemStyle} eventKey="10">
        <Accordion.Header>
          <h2 className={headerStyle}>Section autre images du produit</h2>
        </Accordion.Header>
        <Accordion.Body>
          {productItem?.attributes?.list?.data && (
            <Lists
              listData={productItem?.attributes.list.data}
              fetchProduct={productItem.id}
              resolution="carré"
            />
          )}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item className={itemStyle} eventKey="8">
        <Accordion.Header>
          <h2 className={headerStyle}>Séction caracteristiques</h2>
        </Accordion.Header>
        <Accordion.Body>
          {caracteristiques.map((element) => {
            const isAvailable =
              productItem.attributes.caracteristiques.data.some(
                (prodCaracteristique) => prodCaracteristique.id === element.id
              );

            return (
              <div className="d-inline me-4" key={element.id}>
                <Form.Check
                  inline
                  label={element.attributes.name}
                  // value={itemValue.value}
                  // defaultValue="2"
                  defaultChecked={isAvailable}
                  type="checkbox"
                  onChange={(e) =>
                    handleSwitchChange(element.id, e.target.checked)
                  }
                />
              </div>
            );
          })}
          <Form className="mt-4 d-flex justify-content-center gap-3">
            <Form.Group controlId="newCaracteristique">
              <Form.Label>Ajouter une nouvelle caractéristique</Form.Label>
              <Form.Control
                type="text"
                value={newCaracteristique}
                onChange={(e) => setNewCaracteristique(e.target.value)}
                placeholder="Nom de la caractéristique"
              />
            </Form.Group>
            <Button
              variant="primary"
              className="mt-auto text-white"
              onClick={addCaracteristique}
              disabled={!newCaracteristique.trim()}
            >
              Ajouter
            </Button>
          </Form>
          <ProductSubmitButton
            handleUpdateProduct={handleUpdateProduct}
            productInputs={productInputs}
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default ProductForm;
